module.exports = __webpack_public_path__ + "static/media/parking1.4e93ae9e.svg";